import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Tabs } from 'element-react';
import CommonTitile from '../common-title/index';
import { Link, withRouter } from 'react-router-dom';
import 'element-theme-default'; // 引入 element 主题
import "./card.scss";

class Card extends Component {

  handleClickItem(flag) {
    this.props.history.push({
      pathname: '/detail/' + flag.get('id'), state: {
        type: 1,
        id: flag.get('id'),
        title: flag.get('name')
      }
    });
  }

  render() {

    const { achieve } = this.props;

    return (
      <div className="card">
        <div className="card__content">
          <CommonTitile title="成果专区"></CommonTitile>

          <Tabs value="1">
            {
              achieve.map((item) => {
                return (
                  <Tabs.Pane label={item.get('name')} name={item.get('val')} key={item.get('val')}>
                    <ul className="card__content--group">
                      {
                        item.get('list').map((i) => {
                          return (
                            <li className="card__content--item b_img" key={i.get('id')} onClick={this.handleClickItem.bind(this, i)}>
                              <img className="head-img" src={i.get('file')} alt=""></img>
                              <h2 className="title">{i.get('name')}</h2>
                              <p className="l-desc">{i.get('account')}</p>
                              {
                                i.get('operation').map((j, index) => {
                                  if (index === 0) {
                                    return (
                                      <p className="type" key={index}>需求类型:{j}</p>
                                    )
                                  }
                                })
                              }
                              {
                                i.get('maturity') && (
                                  <p className="type">成熟度:{i.get('maturity')}</p>
                                )
                              }
                              <p className='link'>查看详情 <i className="iconfont">&#xe664;</i></p>
                            </li>
                          )
                        })
                      }
                    </ul>
                  </Tabs.Pane>
                )
              })
            }
          </Tabs>

          <div className="card__more">
            <Link to="/achievement" className="link">查看更多<i className="iconfont">&#xe664;</i></Link>
          </div>
        </div>
      </div>
    )
  }
}

const mapState = (state) => ({
  achieve: state.getIn(['home', 'achieve'])
});

export default withRouter(connect(mapState, null)(Card));
